import{jsxs as o,jsx as t,Fragment as e}from"react/jsx-runtime";import r,{useState as n,useLayoutEffect as a}from"react";import{MdPause as s}from"../node_modules/@react-icons/all-files/md/MdPause.js";import{MdPlayArrow as i}from"../node_modules/@react-icons/all-files/md/MdPlayArrow.js";import l from"styled-components";import{useFallbackVideo as u}from"../hooks/useFallbackVideo.js";import{useHover as c}from"../hooks/useHover.js";const m=l.button`
  padding: 0;
  margin: 0;
  position: absolute;
  opacity: 0.75;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #e0e0e0;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  ${({RTLLayout:o})=>o&&"transform: rotate(180deg) translate(50%, 50%);"}

  &:hover {
    opacity: 1;
  }
`,d=l.video`
  display: block;
  width: 100%;
  position: relative;
  object-fit: cover;
  height: 100%;
  background: #000000;
`,p=l.div`
  position: relative;
  height: 100%;
  width: 100%;

  ${({isLoaded:o,thumbnailUrl:t})=>!o&&t&&`\n    &::before {\n      content: url(${t})};\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      z-index: 1;\n    }\n  `}
`,f=r.forwardRef((({src:r,thumbnailUrl:l,poster:f,className:h,customPlayButton:y,customPauseButton:L,volume:b,onError:v,onClick:k,onTimeUpdate:P,RTLLayout:g},T)=>{const[j,R]=n(!1),[U,w]=n(!1),[x,B]=c({mouseEnterDelayMS:0}),C=u(r,j,f),{error:M}=C;a((()=>{C.ref.current&&void 0!==b&&(C.ref.current.volume=b)}),[C.ref,b]);const N=o=>{P&&P(o)},z=o=>{o.stopPropagation(),R((o=>!o))};if(v&&M&&v(M),M)return null;return o(p,{...B,className:h,isLoaded:U,onClick:k,thumbnailUrl:l,children:[t(d,{...C,ref:o=>{T&&("function"==typeof T?T(o):T&&(T.current=o)),C.ref.current=o},controls:!1,"data-test":"video-element",onEnded:()=>R(!1),onLoadedData:()=>{w(!0)},onLoadedMetadata:N,onTimeUpdate:N}),j?x&&t((()=>L?t(L,{onClick:z}):t(m,{onClick:z,RTLLayout:g,children:t(s,{size:26})})),{}):t((()=>t(e,{children:y?t(y,{onClick:z}):t(m,{onClick:z,RTLLayout:g,children:t(i,{size:26})})})),{})]})}));const h=r.memo(f,(function(o,t){return o.src===t.src&&o.thumbnailUrl===t.thumbnailUrl&&o.poster===t.poster&&o.volume===t.volume&&o.className===t.className&&o.RTLLayout===t.RTLLayout&&o.customPlayButton===t.customPlayButton&&o.customPauseButton===t.customPauseButton}));export{h as Video};
//# sourceMappingURL=Video.js.map
